import * as React from "react";

export const AppDispatch = React.createContext({} as Function);

type LocationType = {
    description: string;
    headline: string;
    icon: React.ReactElement | null;
    id: number | string | null;
    type: string | null;
    latitude?: number | undefined | null;
    longitude?: number | undefined | null;
    subline?: string;
};

export type localState = {
    foundResults?: LocationType[];
    showResults?: boolean;
    showLoading?: boolean;
};

export const AppState = React.createContext({} as localState);
